import { queryAllAssignedForms } from 'src/gql/queries/queryAllAssignedForms'
import { queryAssignedFormsByPatientName } from 'src/gql/queries/queryAssignedFormsByPatientName'

export const assignedFormsServices = {
  getAllAssignedForms: queryAllAssignedForms,
  getAssignedFormsByPatientName: queryAssignedFormsByPatientName,
}

export type AssignedFormsServices = typeof assignedFormsServices
